import { Button, EmptyState, Illustration } from '@tomo/ui';
import { isRouteErrorResponse, Link, useParams, useRouteError } from 'react-router';
import type { LaunchState } from '../projects/Launch.tsx';

export function NotFound() {
  return (
    <div className="center-screen">
      <EmptyState
        size="lg"
        art={<Illustration name="search" />}
        title="Nothing here"
        description="This page wandered off into the fog of war."
        actions={
          <Link to="/">
            <Button variant="primary">Back to Tomo</Button>
          </Link>
        }
      />
    </div>
  );
}

export function RouteError() {
  const error = useRouteError();
  const { projectId } = useParams();
  const message = isRouteErrorResponse(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : String(error);
  console.error(error);
  return (
    <div className="center-screen">
      <EmptyState
        size="lg"
        art={<Illustration name="dice" />}
        title="Critical miss"
        description={
          <>
            Something went wrong while rendering this page.
            <br />
            <code style={{ fontSize: 12, color: 'var(--fg-subtle)' }}>{message}</code>
          </>
        }
        actions={
          <>
            <Button onClick={() => window.location.reload()}>Reload</Button>
            {/* `/` reopens the last project, which may be the one that just failed: pass over it. */}
            <Link to="/" state={projectId ? ({ skip: projectId } satisfies LaunchState) : undefined}>
              <Button variant="primary">{projectId ? 'Open another project' : 'Back to Tomo'}</Button>
            </Link>
          </>
        }
      />
    </div>
  );
}
